import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_THUMBNAIL_CONTENT = {
  Image: "image",
  Icon: "icon",
  Text: "text",
} as const;

export type DSThumbnailContent = ObjectValues<typeof DS_THUMBNAIL_CONTENT>;
